<template>
<div class="chapter">
<div class="inner_page">
<div id="fm3">
<p class="head"><span class="small">OTHER BOOKS BY DARCEY STEINKE</span></p>
<p class="head1"><em class="italic">SUICIDE BLONDE</em></p>
<p class="head1"><em class="italic">JESUS SAVES</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// other_books_by.vue?2604e3bc